import PropTypes from 'prop-types';

import { formatData } from '@/utils/itemSelectorUtils';
import {
  countOthersAvailablesFormats,
  getAttributeId,
} from '@/utils/productUtils';

import Tag from '@/components/common/Tag';

import styles from './ProductCardFormat.module.scss';

export const ProductCardFormat = ({ t, currentItem, productItems, onClick }) => {
  const { label } = formatData(t, currentItem);
  const formatValueId = getAttributeId(currentItem, 'format');
  const countAvailableFormat = countOthersAvailablesFormats(formatValueId, productItems);

  return (
    <div className={styles.container} data-test-id="product-card-format" onClick={onClick}>
      <Tag isSmall hoverable={false}>
        {label}
      </Tag>
      {countAvailableFormat > 0 && (
        <span className={styles.count} data-test-id="nb-format">
          {t('category:productCard.format', { count: countAvailableFormat })}
        </span>
      )}
    </div>
  );
};

ProductCardFormat.propTypes = {
  t: PropTypes.func.isRequired,
  currentItem: PropTypes.object.isRequired,
  productItems: PropTypes.array
};

export default ProductCardFormat;
